<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button *ngIf="isAndroid" type="button" (click)="exitApp()">
        <ion-icon name="exit-outline"></ion-icon>&nbsp; Exit
      </ion-button>
    </ion-buttons>

    <ion-title>Checklist</ion-title>

    <ion-buttons slot="end">
      <ion-button type="button" [disabled]="createButtonEnabled" (click)="createNewCheckList()">
        <ion-icon name="person-add-outline"></ion-icon>&nbsp; NEW
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" #content>
  <ion-grid class="banner">
    <ion-row>
      <ion-col class="ion-align-self-center margintop">
        <ion-label class="banner-title">{{ checklist.length }} Checklist(s) found</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-card *ngFor="let checkItem of checklist; let idx = index; trackBy: trackById" class="view-mode">
  <ion-card-header>
    <ion-grid class="myChecklist">
      <ion-row>
        <ion-col>
          <ion-card-title>{{ checkItem.organisation.subType }}</ion-card-title>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="margin-auto">
          <ion-card-subtitle>{{ checkItem.organisation.entityType }}</ion-card-subtitle>
        </ion-col>

        <ion-col class="text-align-right">
          <ion-icon size="small" name="create-outline" *ngIf="!checkItem.declaration.submissionDateTime" (click)="editDetails(checkItem)"></ion-icon>
          <ion-icon size="small" name="trash-outline" *ngIf="!checkItem.declaration.submissionDateTime" (click)="deleteDetails(checkItem)"></ion-icon>
          <ion-icon size="small" name="share-outline" *ngIf="!checkItem.referenceId && checkItem.declaration.submissionDateTime && isVisible[idx]" (click)="processItem(idx)"></ion-icon>
          <ion-icon size="small" name="eye-outline" *ngIf="checkItem.declaration.submissionDateTime" (click)="viewDetails(checkItem)"></ion-icon>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-header>

  <ion-card-content>
    <ion-list>
      <ion-item>
        <ion-label class="item-title">Association Name</ion-label>
        <ion-label class="item-content" *ngIf="checkItem.organisation.entityTypeName">{{ checkItem.organisation.entityTypeName }}</ion-label>
        <ion-label class="item-content item-empty-content" *ngIf="!checkItem.organisation.entityTypeName">&lt;empty&gt;</ion-label>
      </ion-item>
      <ion-item>
        <ion-label class="item-title">Type</ion-label>
        <ion-label class="item-content" *ngIf="checkItem.organisation.subEntityType">{{ checkItem.organisation.subEntityType }}</ion-label>
        <ion-label class="item-content item-empty-content" *ngIf="!checkItem.organisation.subEntityType">&lt;empty&gt;</ion-label>
      </ion-item>
      <ion-item>
        <ion-label class="item-title">Club Name</ion-label>
        <ion-label class="item-content" *ngIf="checkItem.organisation.subEntityName">{{ checkItem.organisation.subEntityName }}</ion-label>
        <ion-label class="item-content item-empty-content" *ngIf="!checkItem.organisation.subEntityName">&lt;empty&gt;</ion-label>
      </ion-item>
      <ion-item>
        <ion-label class="item-title">Inspection Date</ion-label>
        <ion-label class="item-content" *ngIf="checkItem.organisation.inspectionDateTime">{{ checkItem.organisation.inspectionDateTime | date:'dd-MM-yyyy HH:mm' }}</ion-label>
        <ion-label class="item-content item-empty-content" *ngIf="!checkItem.organisation.inspectionDateTime">&lt;empty&gt;</ion-label>
      </ion-item>
      <ion-item>
        <ion-label class="item-title">Submission Date</ion-label>
        <ion-label class="item-content" *ngIf="checkItem.declaration.submissionDateTime">{{ checkItem.declaration.submissionDateTime }}</ion-label>
        <ion-label class="item-content item-empty-content" *ngIf="!checkItem.declaration.submissionDateTime">&lt;empty&gt;</ion-label>
      </ion-item>
      <ion-item>
        <ion-label class="item-title">Process Id</ion-label>
        <ion-label class="text-align-right">{{( checkItem.referenceId? checkItem.referenceId : checkItem.itemId.split('-').pop())|uppercase }}</ion-label>          
      </ion-item>
    </ion-list>
  </ion-card-content>

  </ion-card>

  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  
</ion-content>